import React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Typography } from '@mui/material';

const AboutModal = ({handleClose}) => {

    return (
        <Box className="about-centered-rectangle"         sx={{
            width: 600,
            height: 1000,
            borderRadius: 7, // Rounded corners
            boxShadow: 3, // Optional: Adds shadow for depth
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
<Typography color="primary">
    <h2>למצוא את הכלים</h2>
    <p>
    למצוא את הכלים הוא פרויקט חדשני המשלב מציאות מדומה (VR) ופלטפורמת Web במטרה לספק כלים מעשיים ותרגול חווייתי להתמודדות עם אתגרים רגשיים, חברתיים ובינאישיים.
    </p>
    <p>
    המערכת מבוססת על סימולציות אינטראקטיביות המאפשרות למשתמשים להתנסות בסיטואציות מציאותיות, לפתח כישורי תקשורת והתמודדות, ולחזק חוסן אישי וקבוצתי. באמצעות שילוב למידה חווייתית עם טכנולוגיה מתקדמת, המשתמשים יכולים לתרגל תגובה למצבי לחץ, קבלת החלטות, ניהול דיאלוגים רגישים, וחיזוק יכולות בינאישיות.
</p>
    <p>
    המערכת פותחה בגישה מודולרית וגמישה, מה שמאפשר התאמה למגוון תחומים ואוכלוסיות, לרבות מסגרות חינוכיות, קהילתיות, ארגוניות וטיפוליות. המטרה המרכזית היא ליצור מרחב בטוח לתרגול ולמידה, שבו המשתמשים יכולים לחוות מצבי אמת, לקבל משוב מיידי ולשפר את יכולותיהם בצורה מעמיקה ויעילה.
</p>
<p>
הפרויקט מבוסס על מחקרים מתחומי הפסיכולוגיה, החינוך והטכנולוגיה, והוא נועד להנגיש למידה חווייתית שמובילה לשינוי תפיסתי ויישומי בעולם האמיתי.
</p>
</Typography>
            </Box>
    );
};

export default AboutModal;
